module.exports = __webpack_public_path__ + "img/door-close.2fbd5656.svg";